import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useCheckoutBoxStyles = makeStyles({
    subheader: {
        fontSize: tokens.fontSizeHero700,
        ...shorthands.margin('0'),
        lineHeight: '100%'
    },
    container: {
        ...shorthands.border('2px', 'solid', tokens.colorNeutralBackground3),
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        ...shorthands.padding(tokens.spacingHorizontalXXL, tokens.spacingHorizontalXL),
        marginBottom: tokens.spacingVerticalXXXL
    },
    hr: {
        marginTop: tokens.spacingVerticalL,
        marginBottom: tokens.spacingVerticalL
    }
});

export default useCheckoutBoxStyles;
